import React, { useEffect, useRef, useCallback } from "react"
import { Navigate, useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { getRole } from "common/Constants"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  // to hide the content from subadmin start

  const Role = getRole()

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("मेनू")} </li>

            <li>
              <Link to="/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("डॅशबोर्ड")}</span>
              </Link>
            </li>

            <li>
              <Link to="/farmer/index">
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("नवीन खाते")}</span>
              </Link>
            </li>

            <li id="farmerList">
              <Link to="/farmer/Listindex">
                <i className="bx bx-file"></i>
                <span>{props.t("यादी(शेतकरी/व्यापारी)")}</span>
              </Link>
            </li>
            <li id="farmerorderList">
              <Link to="/farmerorderlist">
                <i className="bx bx-file"></i>
                <span>{props.t("अगामी खरेदी ऑर्डर ")}</span>
              </Link>
            </li>
            <li id="order">
              <Link to="/#" className="has-arrow">
                <i className="bx bx-task"></i>
                <span>{props.t("ऑर्डर ")}</span>
              </Link>
              <ul className="sub-menu" id="order-ul">
                <li>
                {<Link to="/Salesorder">{props.t("विक्री ऑर्डर")}</Link>}
                </li>
                <li>
                  <Link to="/Purchaseorder">{props.t("खरेदी ऑर्डर")}</Link>
                </li>
              </ul>
            </li>

            <li id="invoice">
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-receipt"></i>
                <span>{props.t("इनव्हॉइस")}</span>
              </Link>
              <ul className="sub-menu" id="invoice-ul">
                <li>
                  {Role == 1 &&  (<Link to="/SalesInvoicelist">
                    {props.t("विक्री इनव्हॉइस")}
                  </Link>) }
                </li>

                <li>
                  <Link to="/purchaselist">{props.t("खरेदी इनव्हॉइस")}</Link>
                </li>
                <li>
                  <Link to="/VehicleInvoice">{props.t("वाहतुक इनव्हॉइस")}</Link>
                </li>

              </ul>
            </li>
            {/* <li id="paymentlist" className="has-arrow ">
              <Link to="/paymentlist">
                <i className="bx bxs-detail"></i>
                <span>{props.t("पेमेंट")}</span>
              </Link>
            </li> */}
            <li id="paymentlist">
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-detail"></i>
                <span>{props.t("पेमेंट")}</span>
              </Link>
              <ul className="sub-menu" id="payment-ul">
                <li>
                  {Role == 1 &&  (<Link to="/farmerpayment">
                    {props.t("शेतकरी ")}
                  </Link>) }
                </li>

                <li>
                  <Link to="/merchantpayment">{props.t("व्यापारी")}</Link>
                </li>
                <li>
                  <Link to="/businesspayment">{props.t("इतर")}</Link>
                </li>

              </ul>
            </li>
            <li id="leadegerlist">
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-food-menu"></i>
                <span>{props.t("लेडजर")}</span>
              </Link>
              <ul className="sub-menu" id="payment-ul">
                <li>
                  {Role == 1 &&  (<Link to="/farmerleadger">
                    {props.t("शेतकरी ")}
                  </Link>) }
                </li>

                <li>
                  <Link to="/merchantleadger">{props.t("व्यापारी")}</Link>
                </li>
                <li>
                  <Link to="/businessleadger">{props.t("इतर")}</Link>
                </li>

              </ul>
            </li>
            {/* <li id="">
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-duplicate"></i>
                <span>{props.t("माहिती")}</span>
              </Link>
              <ul className="sub-menu" id="invoice-ul">
                <li>
                  {Role == 1 &&  (<Link to="/Taluka">
                    {props.t("तालुका")}
                  </Link>) }
                </li>

                <li>
                  <Link to="/District">{props.t("जिल्हा")}</Link>
                </li>
              

              </ul>
            </li> */}
         
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
